import { DumpLoadStatus } from '@common/enums';
import React, { FC, useMemo } from 'react';

import { FormikSelectField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { useProjectTimeSpentFormikContext } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentEditForm/ProjectTimeSpentFormik';
import { TimeSpentDumpLoad } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/types';

export const ProjectTimeSpentOrderSelect: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const formik = useProjectTimeSpentFormikContext();

    // Allow change only to the IN_PROGRESS dump load
    const items: TimeSpentDumpLoad[] = useMemo(
        () => formik.values.project.dumpLoads.filter(d => !d.inbound && d.status === DumpLoadStatus.IN_PROGRESS),
        [formik]
    );

    return (
        <FormikSelectField
            label={<LocalizableText code={'ProjectDocuments.timeSpent.dumpLoadNumber'} />}
            name={'dumpLoad'}
            formik={formik}
            items={items}
            renderValue={(dumpLoad: TimeSpentDumpLoad) => dumpLoad.serialNumber}
            keyGetter={(dumpLoad: TimeSpentDumpLoad) => dumpLoad.serialNumber}
            disabled={disabled}
            addEmptyOption={false}
        />
    );
};
